import * as React from 'react';
import { Link } from 'react-router-dom';
import logoen from '../logo-en.svg';
import AuthService from '../services/auth.service';

class Header extends React.PureComponent<any> {

    private handleLogout = () => {
        if (this.props && this.props.history) {
            AuthService.logout();
            this.props.history.push('/login');
        } else if (this.props && this.props.props && this.props.props.history) {
            AuthService.logout();
            this.props.props.history.push('/login');
        }
    }
    public render() {
        const user = AuthService.getCurrentUser();
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col">
                        <img src={logoen} alt="logo" className="img-fluid ms-1 mb-2" style={{maxWidth: '15%', height: 'auto'}}></img>
                    </div>
                    {
                        user.accessToken &&
                        <div className="col d-flex flex-row-reverse">
                            <div className="btn-group">
                                <button type="button" className="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                    {user.firstName}
                                </button>
                                <ul className="dropdown-menu">
                                    <li><Link className="dropdown-item" to={`/changepassword`}>Change Password</Link></li>
                                    <li><hr className="dropdown-divider"></hr></li>
                                    <li><button className="dropdown-item" onClick={this.handleLogout}>Logout</button></li>
                                </ul>
                            </div>
                            <span className="mt-lg-3">
                            &nbsp;
                            Welcome,&nbsp;
                            </span>
                        </div>
                    }
                </div>
                <div className="row mb-4">
                    <div className="col">
                        <div className="progress" style={{height: '4px'}}>
                            <div className="progress-bar bg-success" role="progressbar" style={{width: '0%'}} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100}></div>
                        </div>
                        <div className="progress" style={{height: '3px'}}>
                            <div className="progress-bar bg-warning" role="progressbar" style={{width: '100%'}} aria-valuenow={75} aria-valuemin={0} aria-valuemax={100}></div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
};

export default Header;
